import React from 'react';

const BuyNowPayLater = ({ total, currency, symbol = '$' }) => {
  if (!total || total < 30) return null; // BNPL providers usually require min ~$30/£30/€30
  const installment = (Number(total) / 4).toFixed(2);
  const sym = (() => {
    if (currency === 'GBP') return '£';
    if (currency === 'EUR') return '€';
    if (currency === 'CAD') return 'CA$';
    return symbol || '$';
  })();
  return (
    <div className="mt-3 flex items-center gap-2 text-[13px] leading-tight" style={{ color: '#2C2418' }}>
      <span>or 4 interest-free payments of</span>
      <span className="font-semibold">{sym}{installment}</span>
      <span>with</span>
      <span
        className="px-2 py-0.5 rounded text-[10px] font-bold tracking-wide"
        style={{ backgroundColor: '#FFA8C5', color: '#0A0908' }}
      >
        Klarna
      </span>
      <span style={{ color: '#9CA3A2' }}>·</span>
      <span
        className="px-2 py-0.5 rounded text-[10px] font-bold tracking-wide"
        style={{ backgroundColor: '#B2FCE4', color: '#0A0908' }}
      >
        Afterpay
      </span>
    </div>
  );
};

export default BuyNowPayLater;
